import React from "react";
import MuiBreadcrumbs from "@material-ui/core/Breadcrumbs";
import PropTypes from "prop-types";

/**
 * Breadcrumbs component wrapper for navigation breadcrumbs.
 * Wraps Material-UI Breadcrumbs with theme integration.
 * 
 * @component
 * @example
 * <Breadcrumbs aria-label="Breadcrumb" separator=">">
 *   <Link to="/">Home</Link>
 *   <Link to="/products">Products</Link>
 *   <Typography color="textPrimary">Current Page</Typography>
 * </Breadcrumbs>
 */
const Breadcrumbs = ({ children, ...props }) => {
  return <MuiBreadcrumbs {...props}>{children}</MuiBreadcrumbs>;
};

Breadcrumbs.propTypes = {
  /**
   * The content of the component
   */
  children: PropTypes.node,
  /**
   * The component used for the root node
   */
  component: PropTypes.elementType,
  /**
   * Override the default label for the expand button
   */
  expandText: PropTypes.string,
  /**
   * If maxItems is exceeded, the number of items to show after the ellipsis
   */
  itemsAfterCollapse: PropTypes.number,
  /**
   * If maxItems is exceeded, the number of items to show before the ellipsis
   */
  itemsBeforeCollapse: PropTypes.number,
  /**
   * Specifies the maximum number of breadcrumbs to display
   */
  maxItems: PropTypes.number,
  /**
   * Custom separator node
   */
  separator: PropTypes.node,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles
   */
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])
    ),
    PropTypes.func,
    PropTypes.object,
  ]),
};

// No defaultProps - maintain exact MUI Breadcrumbs behavior

export default Breadcrumbs;



